import * as React from "react";
import styled, { css } from "styled-components";
import { Colors } from "@origin-digital/style-guide";

import { Metrics, Palette, ToolbarItemPropTypes } from "../../vars";

const propTypes = {
  ...ToolbarItemPropTypes
};

const ToolbarButton: React.SFC<any> = ({
  children,
  icon,
  isActive,
  href,
  ...otherProps
}) => (
  <a href={href} {...otherProps}>
    {icon && <i className="md-icon">{icon}</i>}
    <span>{children}</span>
  </a>
);

ToolbarButton.propTypes = propTypes;

export default styled(ToolbarButton)`
  font-size: ${Metrics.FontSizes.TOOLBAR_ITEM_TEXT}px;
  line-height: ${Metrics.LineHeights.TOOLBAR_ITEM_TEXT}px;
  padding: ${Metrics.Padding.TOOLBAR_ITEM_Y}px
    ${Metrics.Padding.TOOLBAR_ITEM_X}px;
  color: ${Palette.Rebrand.Colours.G5};
  text-decoration: none;
  border-left: 1px solid ${Palette.Rebrand.Colours.G3};

  .style--rebrand & {
    text-decoration: none;

    i {
      color: ${Colors.GREY48};
    }

    ${props =>
      props.active &&
      css`
        span {
          border-bottom: 2px solid ${Palette.Rebrand.Colours.P4};
          padding-bottom: 1px;
        }
      `};
  }

  .style--rebrand &:hover {
    text-decoration: none;
    color: ${Palette.Rebrand.Colours.P1};

    i {
      color: ${Palette.Rebrand.Colours.P1};
    }
  }
`;
